import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CheckFBInSystem, LoginModel } from 'src/app/shared/models/login.model';
import { AuthService } from 'src/app/core/services/auth/auth.service';

interface ResLogout {
  message: string;
  result: {
    LOGOUTTIME: string;
    USER_ID: string;
  }
  success: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  login(data) {
    let body = {
      EMAIL: data.EMAIL,
      PASSWORD: data.PASSWORD,
      TYPE_LOGIN: data.TYPE_LOGIN,
      TOKEN_NOTI: '',
      DEVICE_ID: '',
      TYPE_DEVICE_LOGIN: data.TYPE_DEVICE_LOGIN,
      FB_ID: data.FB_ID,
      APPLE_ID: ''
      // TYPE_DEVICE_LOGIN: this.deviceService.getDeviceInfo().deviceType
    }
    // // console.log(body);
    return this.http.post<LoginModel>(environment.URL + '/authen/Login', body)
  }

  checkFBIDInSystem(id: string) {
    return this.http.post<CheckFBInSystem>(environment.URL + '/authen/CheckFBIDInSystem', { FB_ID: id });
  }

  logout() {
    const headers = new HttpHeaders({
      Authorization: this.authService.getToken(),
    })

    return this.http.post<ResLogout>(environment.URL + '/authen/Logout', {}, { headers: headers })
  }
}
